var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FF7000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 22.6C14.25 22.6 13.2 21.55 13.2 20.2C13.2 18.8875 14.25 17.8 15.6 17.8C16.9125 17.8 18 18.8875 18 20.2C18 21.55 16.9125 22.6 15.6 22.6ZM32.4 22.6C31.05 22.6 30 21.55 30 20.2C30 18.8875 31.05 17.8 32.4 17.8C33.7125 17.8 34.8 18.8875 34.8 20.2C34.8 21.55 33.7125 22.6 32.4 22.6ZM33.6 23.8C34.9125 23.8 36 24.8875 36 26.2V27.4C36 28.075 35.4375 28.6 34.8 28.6H32.325C32.0625 26.8375 31.0125 25.3375 29.475 24.5125C29.925 24.1 30.525 23.8 31.2 23.8H33.6ZM24 23.8C21.675 23.8 19.8 21.925 19.8 19.6C19.8 17.3125 21.675 15.4 24 15.4C26.2875 15.4 28.2 17.3125 28.2 19.6C28.2 21.925 26.2875 23.8 24 23.8ZM26.85 25C29.25 25 31.2 26.95 31.2 29.35V30.4C31.2 31.4125 30.375 32.2 29.4 32.2H18.6C17.5875 32.2 16.8 31.4125 16.8 30.4V29.35C16.8 26.95 18.7125 25 21.1125 25H21.4125C22.2 25.375 23.0625 25.6 24 25.6C24.9 25.6 25.7625 25.375 26.55 25H26.85ZM18.4875 24.5125C16.95 25.3375 15.9 26.8375 15.6375 28.6H13.2C12.525 28.6 12 28.075 12 27.4V26.2C12 24.8875 13.05 23.8 14.4 23.8H16.8C17.4375 23.8 18.0375 24.1 18.4875 24.5125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups);
export default __webpack_public_path__ + "static/media/groups.0dcdecc48073c62c142015f1416005a9.svg";
export { ForwardRef as ReactComponent };